import { Title, Flex, FileButton, Button } from '@mantine/core';
import {
  // IconTrash,
  IconUpload,
  // IconPlus,
} from '@tabler/icons-react';

import { useConfigImages } from '../../hooks/use-config-images';
import { ImagesTable } from './images-table';

export const Images = () => {
  const {
    params,
    items,
    itemsCount,
    isLoading,
    handleUploadImage,
    handleDeleteImage,
    handlePageChange,
  } = useConfigImages();

  return (
    <>
      <Flex justify="space-between" align="center" w="100%" mb={10}>
        <Title order={4}>Картинки</Title>

        <FileButton onChange={handleUploadImage} accept="image/png,image/jpeg">
          {(props) => (
            <Button
              // size="xs"
              variant="filled"
              leftSection={<IconUpload size={12} />}
              loading={isLoading}
              {...props}
            >
              Загрузить картинку
            </Button>
          )}
        </FileButton>
      </Flex>

      <ImagesTable
        items={items}
        isLoading={isLoading}
        itemsCount={itemsCount}
        pageSize={params.pageSize}
        currentPage={params.page}
        onPageChange={handlePageChange}
        handleDeleteImage={handleDeleteImage}
      />
    </>
  );
};
